<script>
  import { onMount } from 'svelte';
  import { Row, Container , Col} from 'sveltestrap';

  let data = {};
  async function getData(){
    let location = await localStorage.getItem('LANGUAGE') || 'es-CL';
		if (location === 'es') {
			location = 'es-CL';
		}
		var requestOptions = {
		method: 'GET',
		redirect: 'follow'
		};
		fetch(`https://api.rastros.cl/api/home-screen?populate=%2A&locale=${location}`, requestOptions)
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		})
		.then(result => {
			data = result.data;
		})
		.catch(error => {
			console.error('Error al contactar al servicio de home-screen en Footer:', error);
			data = {}; // Initialize data as an empty object to prevent TypeError
		});
	}

  onMount(async () => {
		await getData();
  	});
</script>
<footer class="footer">
    <Container fluid={true}>
      <Row>
        <Col md={6}>{new Date().getFullYear()} © {data.copyright}</Col>
        <Col md={6}>
          <div class="text-sm-end d-none d-sm-block">
            {data.partner}
          </div>
        </Col>
      </Row>
    </Container>
  </footer>